import { render, staticRenderFns } from "./PercentageChange.vue?vue&type=template&id=39cf9a1a&scoped=true&"
import script from "./PercentageChange.vue?vue&type=script&lang=js&"
export * from "./PercentageChange.vue?vue&type=script&lang=js&"
import style0 from "./PercentageChange.vue?vue&type=style&index=0&id=39cf9a1a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39cf9a1a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/lee/Developer/Auris/admin-portal/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('39cf9a1a')) {
      api.createRecord('39cf9a1a', component.options)
    } else {
      api.reload('39cf9a1a', component.options)
    }
    module.hot.accept("./PercentageChange.vue?vue&type=template&id=39cf9a1a&scoped=true&", function () {
      api.rerender('39cf9a1a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/PercentageChange.vue"
export default component.exports